import { AxiosError } from "axios";
import { AppErrorToast } from "../components/common";

type ApiErrorBody = {
  Code?: string;
  Message?: string;
};

const getApiErrorBody = (error: AxiosError): ApiErrorBody | undefined =>
  error.response?.data as ApiErrorBody | undefined;

function toastApiMessageOr(error: AxiosError, fallback: string) {
  const msg = getApiErrorBody(error)?.Message?.trim();
  AppErrorToast(msg || fallback);
}

export default function errorHandler(error: AxiosError) {
  if (error.response?.status === 400) {
    handleBadRequest(error);
  } else if (error.response?.status === 401) {
    AppErrorToast("Nieautoryzowany dostęp");
  } else if (error.response?.status === 404) {
    AppErrorToast("Błąd komunikacji z serwerem");
  } else if (error.response?.status === 500) {
    AppErrorToast("Błąd serwera");
  } else {
    AppErrorToast("Błąd zapytania");
  }
}

const handleBadRequest = (error: AxiosError) => {
  const code = getApiErrorBody(error)?.Code;

  switch (code) {
    case "worktime_edition_failure":
      AppErrorToast("Przedział czasu pracy pokrywa się z okresami innych czasów pracy");
      break;
    case "invalid_worktime_span":
      AppErrorToast("Godzina rozpoczęcia okresu pracy musi być wcześniejsza niż godzina zakończenia");
      break;
    case "invalid_year_value":
      AppErrorToast("Nieprawidłowy rok");
      break;
    case "invalid_month_value":
      AppErrorToast("Nieprawidłowy miesiąc");
      break;
    case "invalid_work_hours_value":
      AppErrorToast("Godziny pracy muszą być większe niż 0");
      break;
    case "commission_type_change_summary_conflict":
      toastApiMessageOr(
        error,
        "Nie udało się zmienić typu rozliczenia — stan podsumowania nadgodzin nie pozwala na tę korektę."
      );
      break;
    case "summary_not_found":
    case "realization_not_found":
      toastApiMessageOr(error, "Nie można wykonać zmiany typu rozliczenia — brak wymaganych danych.");
      break;
    default:
      AppErrorToast("Nieprawidłowe zapytanie");
      break;
  }
}
